<div class="lei-content">
  @if (loading) {
    <div class="loading-overlay" aria-live="polite" aria-label="Loading legal entity information">
      <div class="overlay-content">
        <app-spinner [display]="true" [diameter]="48" aria-label="Loading"></app-spinner>
        <span>Loading information…</span>
      </div>
    </div>
  }

  <!-- Entity Identification Section -->
  <app-entity-identification
    [legalEntityId]="entityId"
    [legalEntityName]="legalEntityName"
    [officialRegistrationNumber]="officialRegistrationNumber"
    [associatedAuthorizedSignatory]="associatedAuthorizedSignatory"
    [address]="address"
    [country]="country"
  />
  <!-- Contact Information Section -->
  <app-contact-information
    [legalEntityId]="entityId"
    [contacts]="contactInformation"
    (contactsChanged)="onContactsChanged($event)"
  />

  <!-- B&CS Assessment Section -->
  <app-bncs-assessment
    [legalEntityId]="entityId"
    [bncsDocuments]="bncsAssessmentDocuments"
    [contactCount]="contactInformation.length"
  />

  <!-- DDQ-Specific Fields Section -->
  <app-ddq-specific-fields [legalEntityId]="entityId" [contacts]="contactInformation" />

  <!-- IGA Coordinator Section -->
  <app-iga-coordinator
    [legalEntityId]="entityId"
    [selectedCoordinatorId]="igaCoordinatorId"
    [selectedCoordinatorName]="igaCoordinatorName"
  />

  <!-- Letter of Adherence Tracking Section -->
  <app-loa-tracking [legalEntityId]="entityId" />

  <!-- Add more sections here as needed:
  - app-financial-information
  - app-regulatory-information
  - app-additional-details
  etc.
  -->
</div>
